import React, { forwardRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { styles } from './styles';
import { LIGHT_THEME } from '../../theming/constants';
import { TypographyTags } from './class-name-tags';
const Text = styled.p `
  ${({ theme }) => styles(theme.components.atoms.typography)}
`;
Text.defaultProps = {
    theme: LIGHT_THEME,
};
const typeToHtmlElement = {
    basic: 'p',
    secondary: 'p',
    bold: 'p',
    error: 'p',
    small: 'p',
    'code-snippet': 'code',
    heading1: 'h1',
    heading2: 'h2',
    heading3: 'h3',
};
export const Typography = forwardRef(({ variant = 'basic', className, component, ...rest }, ref) => {
    // Styled Components library types don't accept a polymorphic `as` prop and report an invalid type error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const realAs = component ?? typeToHtmlElement[variant] ?? 'p';
    return (React.createElement(Text, { ref: ref, className: classNames(TypographyTags.root, className, variant), 
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        as: realAs, ...rest }));
});
//# sourceMappingURL=Typography.js.map